export enum ScaleProperties {
  WEIGH_BEFORE = "scaleAutoWeighBeforeMeasure",
  WEIGH_AFTER = "scaleAutoWeighAfterMeasure"
}
